import React, { useRef, useState } from "react"
import { toast } from "react-toastify"

import { uploadImage } from "services"

const FileUploaderWrapper = (props) => {
  const {
    children,
    className,
    imageCategory = "setting",
    onUploadComplete = () => {},
    options = { device: true, link: true }
  } = props

  const inputRef = useRef(null)
  const [uploading, setUploading] = useState(false)

  const uploadFile = async event => {
    const file = event.target.files?.[0]
    event.target.value = ""

    if (!file) return

    setUploading(true)

    try {
      const form = new FormData()
      form.append("qqfile", file, file.name)
      const result = await uploadImage(form, imageCategory)
      onUploadComplete([result.fullUrl || result.url || result.storagePath])
    } catch (error) {
      toast.error("آپلود فایل انجام نشد.")
    } finally {
      setUploading(false)
    }
  }

  const openPicker = () => {
    if (uploading) return

    if (options.link && !options.device) {
      const url = window.prompt("آدرس فایل را وارد کنید")
      if (url) onUploadComplete([url])
      return
    }

    inputRef.current?.click()
  }

  return (
    <>
      <div
        className={className}
        onClick={openPicker}
      >
        {uploading ? "در حال آپلود..." : children}
      </div>
      <input
        ref={inputRef}
        type="file"
        accept="image/*,video/*"
        hidden
        onChange={uploadFile}
      />
    </>
  )
}

export default FileUploaderWrapper
